<script setup lang="ts">
import { onLaunch } from '@dcloudio/uni-app'
import { createPath, getAppId, getCurrentPath, getCurrentPathWithSearch, getCurrentUrl, initiateWxAuth, isInWeixinBrowser, setAppId, updateIdb } from './utils/tools'
import { type ZoneSecret, getLinkInfo } from './api'
import { useChat } from './stores/chat'
import { useLastThirdToken } from './composables/third'
import useAuthStore from '~/stores/auth'
import { DAY } from '~/constants'

function decode(str: string) {
  return JSON.parse(decodeURIComponent(atob(str)))
}

onLaunch(async (ctx) => {
  const appId = ctx?.query.state as string | undefined
  const secret = ctx?.query.secret as string | undefined
  const code = ctx?.query.code as string | undefined
  // from third system
  const thirdToken = ctx?.query.t as string | undefined
  const thirdTokenType = ctx?.query.tp as string | undefined
  const thirdAppId = ctx?.query.appid as string | undefined
  const thirdExtra = (ctx?.query.ext as string | undefined) || ''
  const z = useZone()
  const authStore = useAuthStore()
  let secretInfo: ZoneSecret | undefined

  if (secret) {
    const [err, res] = await getLinkInfo(secret)
    if (!err)
      secretInfo = res.data
  }

  if (appId)
    setAppId(appId)

  if (secretInfo?.zoneCode) {
    if (z.value.zoneCode && z.value.zoneCode !== secretInfo?.zoneCode)
      authStore.logout()
    z.value = secretInfo
  }

  if (!z.value.zoneCode && location.pathname !== '/pages/404') {
    location.href = '/pages/404'
    return
  }

  const vc = useVisitorCode(z.value.zoneCode!)
  const vct = useVisitorCodeRefreshTime(z.value.zoneCode!)

  if (vc.value) {
    if (!vct.value || Date.now() - vct.value > 30 * DAY) {
      vc.value = ''
      vct.value = 0
      await updateIdb([])
    }
  }

  const chatStore = useChat()
  await chatStore.initSettings()

  /** third party auth */
  if (thirdToken) {
    if (thirdTokenType === 'hyc') {
      try {
        const d = decode(thirdToken)
        if (d.token) {
          authStore.setUserRaw(d)
          authStore.isFromThird = true
        }
      }
      catch {}
    }
    else {
      const lastThirdToken = useLastThirdToken(z.value.zoneCode!)
      if (!lastThirdToken || thirdToken !== lastThirdToken.value || !authStore.verifyAndGetUser()) {
        const success = await authStore.loginByThird({ thirdToken, thirdExtra, thirdAppId })
        if (success)
          lastThirdToken.value = thirdToken
      }
    }
  }

  if (chatStore.settings?.allowVisitor !== 'YES' && !authStore.verifyAndGetUser()) {
    /** wechat auth */
    if (isInWeixinBrowser()) {
      if (code) {
        const url = new URL(getCurrentUrl())
        url.searchParams.delete('code')
        history.replaceState(null, '', url.toString())
        await authStore.loginByWechat(code, z.value.zoneCode!)
      }
      else {
        let _appId: string | undefined = appId
        if (!_appId)
          _appId = await getAppId(true)
        if (_appId) {
          initiateWxAuth(getCurrentUrl(), _appId, 'snsapi_base')
          return
        }
        else {
          await h5Path()
        }
      }
    }
    else {
      await h5Path()
    }
  }

  if (!location.pathname.startsWith('/pages/register') && isInWeixinBrowser() && authStore.authed && !authStore.user?.info?.avatar && !authStore.user?.info?.nickname) {
    const appId = await getAppId(true)
    if (appId) {
      authStore.logout()
      if (thirdToken)
        initiateWxAuth(location.origin, appId, 'snsapi_userinfo')
      else
        router.replace(`/pages/userinfo?appId=${appId}`)

      return
    }
  }

  authStore.launched = true
})

async function h5Path() {
  if (!getCurrentPath().startsWith('/pages/register') && location.pathname !== '/pages/404') {
    router.replace(createPath('/pages/register', {
      redirect: getCurrentPathWithSearch(),
    }))
  }
}
</script>
